const reviews = [
  {
    name: 'مصطفى عبدالحليم',
    city: '',
    rating: 5,
    comment: `كان عندنا حفل سحور سنوي للشركه وصراحه أبدعوا

اخص بالذكر الاستاذ ليدر اللي قدم دعم عالي وكمان في اختيار الأصناف اللي لاقت شكر جدا في السحور

وايضا لا انسي الاستاذ اشرف والاستاذ ياسر صراحه في ترتيب وتنسيق المائده بشكل احترافي اشكرهم جدا واتمني لهم التوفيق دائما`,
  },
  {
    name: 'هند',
    city: '',
    rating: 5,
    comment:
      'طلبنا منهم بوفيه vip والصراحة التجربة كانت جميلة. واخص بالشكر صدام ما قصر معنا في الاختيار والترتيب والخدمة. اهني الرومنسية على وجوده',
  },
  {
    name: 'منيرة الراشد',
    city: '',
    rating: 5,
    comment: `مطعم مميز البوفيه مع الذبيحه اكثر من رائع
وشكرا لتعاون المنظمين الاخ ليدر والاخ احمد كانت التجهيزات متكامله`,
  },
  {
    name: 'الجوهرة سعد',
    city: '',
    rating: 5,
    comment:
      'طلبنا بوفيه إفطار وكان مرّة لذيذ.. الصراحة الموظفين الليدر وياسر كانوا قمة في التعامل، واهتموا فينا بشكل كبير من ناحية الترتيب والتنسيق كل شيء كان مرتب وعلى مستوى عالي، وجودة الأكل فاقت توقعاتنا فعلا... يعطيهم العافية على شغلهم، وإن شاء الله مو آخر تجربة لنا معهم',
  },
  {
    name: 'محمد عبدالفضيل',
    city: '',
    rating: 5,
    comment: `تسلم إيدك كابتن ليدر على الاهتمام الكبير وعمل بوفيه مفتوح للشركة عندنا وكان على أكمل وجه
ويسلم إيدك أستاذ ياسر على الخدمة اللي من القلب انت وأفراد عملك
ونعم الفريق`,
  },
  {
    name: 'ايلاف جعفر',
    city: '',
    rating: 5,
    comment:
      'بصراحه تجربة البوفيه عندهم من اروع ما يكون ما قصرو والاكل كان لذيذ جدا وابدعو بالترتيبات بيضو الوجه و على الوقت ما شاء الله عليهم واخص بالشكر والتقدير للاستاذ ليدر و ابو عبيده كثير الشكر',
  },
  {
    name: 'جهاد فضل',
    city: '',
    rating: 5,
    comment: `شكرا مطعم الرومانسية على كل شيء كان افطار رمضاني مميز جدا
شكرا للأخ أيمن وللأخ ليدر ماقصرتم ويعطيكم العافية`,
  },
  {
    name: 'مساعد اليحيى',
    city: '',
    rating: 5,
    comment: `أتقدم بجزيل الشكر والتقدير لكل من السيد ليدر والسيد مصطفى وبيض الله وجيههم على جهودهم المميزة وتنظيمهم الرائع. كان الالتزام بالمواعيد على أعلى مستوى من الاحترافية، مما يعكس حرصهم الكبير على جودة العمل حيث كان هذا الترتيب داخل مقر الشركة
كما أن تنوع البوفيه كان لافتًا ومميزا، حيث لبي مختلف الأذواق بشكل ممتاز الترتيب كان مميزا.
أما بالنسبة للطعام، فكان أكثر من رائع، من حيث التنوع في السلطات والمقبلات وجوده الذبائح، كل الشكر والتقدير`,
  },
  {
    name: 'نوال صالح',
    city: '',
    rating: 5,
    comment:
      'جزاك الله الف خير استاذ ليدر على كل شي في البوفيه تبارك الله كالعاده فوق العشره على العشره والكل اعجب بالترتيب والتوقيت ونوع الاكل',
  },
  {
    name: 'امير بن ظافر',
    city: '',
    rating: 5,
    comment:
      'عشاء بوفيه وتجربه اكثر من رائعه اكل ممتاز خدمه ممتازه وانضباط في المواعيد واهتمام بالنظافه وسلامه الطعام. وشكر خااااص للاستاذ ليدر والاستاذ ابو عبيده. قمه التعامل الراقي',
  },
];

export default reviews;
